import React, { useEffect, useState, memo } from "react";
import ImageShow from "../../../../Uitiles/ImageShow";
import { oneKlicks } from "../../../../SDK/oneclick";
import decodeHtml from "../../../../Uitiles/decodeHtml";
import { formatUrlString } from "../../../../services/apiService";
import { Link } from "react-router-dom";
import DoctorSpecialities from "../../Home/Components/DoctorSpecialities";
import DoctorAvailable from "../../Home/Components/DoctorAvailable";
import { getuserdata, addToWishlist } from "../../../../services/apiService";
import formatDoctorName from "../../../../Uitiles/FormatName";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import Feedbackcount from "../../../../Uitiles/Feedbackcount";
import { useCurrency } from "../../../../context/CurrencyContext";
import GoogleMapsLink from "../../../../components/GoogleMapsLink";

const DoctorListCard = memo(({ doctor, type }) => {
    const [image, setImage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [displayPrice, setDisplayPrice] = useState(doctor?.starting_price || 500);
    const { selectedCurrency, formatPrice, convertPrice, isLoading: currencyLoading } = useCurrency();

    // const formatDoctorName = (name) => {
    //     if (!name) return '';
    //     let formattedName = name.replace(/^dr_/, '');
    //     formattedName = formattedName.split('_')
    //         .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    //         .join(' ');
    //     formattedName = formattedName.replace(/^(Dr\.?\s*)+/i, '');
    //     return `Dr. ${formattedName}`;
    // };

    const truncateAddress = (address) => {
        if (!address) return '';
        // Remove first character if it's a space
        let trimmedAddress = address.startsWith(' ') ? address.slice(1) : address;
        const parts = trimmedAddress.split(',');
        if (parts.length > 2) {
            return parts.slice(0, 2).join(',') + '...';
        }
        return trimmedAddress;
    };

    const encryptId = (id) => {
        const salt = 'meddylist';
        const encrypted = btoa(id + salt);
        return encrypted;
    };


    // Safe JSON parse utility (in case it's not already defined)
    const safeJSONParse = (value) => {
        try {
        return typeof value === "string" ? JSON.parse(value) : value;
        } catch {
        return null;
        }
    };
    
    // Extract the most recent education info from the doctor data
    const getEducationInfo = () => {
        const educationData = doctor?.doctor_experience_education?.[0]?.educations;
    
        if (!educationData) return null;
    
        const educations = safeJSONParse(educationData);
        if (!Array.isArray(educations) || educations.length === 0) return null;
    
        // Sort by start_date or ending_date (optional)
        const sorted = [...educations].sort((a, b) => {
        const dateA = new Date(a.ending_date || a.start_date || 0);
        const dateB = new Date(b.ending_date || b.start_date || 0);
        return dateB - dateA; // latest first
        });
    
        return sorted[0]; // Return latest education
    };
    

    const getSpecializationsInfo = () => {
        if (doctor?.doctor_specialities && doctor.doctor_specialities.length > 0) {
            return doctor.doctor_specialities;
        }
        return null;
    };

    useEffect(() => {
        if (doctor?.image) {
            setImage(doctor.image);
            setIsLoading(false);
        } else {
            setImage("https://via.placeholder.com/150");
            setIsLoading(false);
        }
    }, [doctor]);

    // Handle price conversion when currency changes
    useEffect(() => {
        const updatePrice = async () => {
            if (selectedCurrency === 'INR') {
                setDisplayPrice(doctor?.starting_price || 500);
            } else {
                try {
                    const convertedPrice = await convertPrice(doctor?.starting_price || 500, "INR", selectedCurrency);
                    setDisplayPrice(convertedPrice);
                } catch (error) {
                    console.error('Price conversion failed:', error);
                    setDisplayPrice(doctor?.starting_price || 500);
                }
            }
        };

        updatePrice();
    }, [selectedCurrency, doctor?.starting_price, convertPrice]);

    

    return (
        <div className="dc-searchresult-holder">
            <div className="dc-searchresult-head">
            </div>
            <div className={`dc-searchresult-grid dc-searchresult-list dc-searchvlistvtwo ${doctor.id}`}>
                <div className="dc-docpostholder dc-search-hospitals">
                    <div className="dc-docpostcontent">
                        <div className="dc-searchvtwo col-lg-8 col-md-8 col-sm-8 col-xs-12">
                            <figure className="dc-docpostimg" style={{ display: 'flex', alignItems: 'center' }}>
                                
                                    <ImageShow url={doctor.profile_photo_url} type="doctor" width={150} height={150} style={{ width: 150, height: 'auto', objectFit: 'cover' }} />
                                
                                
                            </figure>
                            <div className="dc-title">
                                <div className="dc-doc-specilities-tag">
                                    <DoctorSpecialities doctorId={doctor.id} data={doctor || [] } type="list"/>
                                </div>
                                <h3>
                                    <Link to={`/${type === "doctor" ? "doctor" : "hospital"}/dr-${formatUrlString(doctor.display_name)}/${encryptId(doctor.id)}`}>{decodeHtml(formatDoctorName(doctor.display_name,type))}</Link>
                                    {doctor.is_verified_medical_registration && (
                                        <i className="icon-sheild dc-awardtooltip dc-tipso tipso_style" data-tipso="Medical Registration Verified"></i>
                                    )}
                                    {doctor.is_verified_user && (
                                        <i className="far fa-check-circle dc-awardtooltip dc-tipso tipso_style" data-tipso="Verified user"></i>
                                    )}
                                </h3>
                                <ul>
                                    {/* <li className="dc-subheading"><em className="dc-subheading-text">{doctor.subheading}</em></li> */}
                                </ul>
                                {/* add ratings */}
                                <Feedbackcount data={doctor} type="list"   />
                                {/* <span><i className="ti-star"></i> {doctor.ratings || 0} Ratings</span> */}
                                
                                                                    {/* Education, Experience and Specializations */}
                                    <div className="dc-education-specializations" style={{ marginTop: '10px' }}>
                                        {/* Education */}
                                        {(() => {
                                            const education = getEducationInfo();
                                            if (education) {
                                                return (
                                                    <div className="dc-education" style={{ 
                                                        fontSize: '12px', 
                                                        color: '#666', 
                                                        marginBottom: '5px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '5px'
                                                    }}>
                                                        <i className="fas fa-graduation-cap" style={{ color: '#3b82f6' }}></i>
                                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '150px' }}>{education?.degree_title || 'Education'}</span>
                                                        {/* {education?.institute_name && (
                                                            <span style={{ color: '#999' }}>• {education.institute_name}</span>
                                                        )} */}
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })()}
                                        
                                        {/* Experience */}
                                        {doctor.experiences && (
                                            <div className="dc-experience" style={{ 
                                                fontSize: '12px', 
                                                color: '#666', 
                                                marginBottom: '5px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px'
                                            }}>
                                                <i className="fas fa-briefcase" style={{ color: '#f59e0b' }}></i>
                                                <span>{doctor.experiences} years experience</span>
                                            </div>
                                        )}
                                        
                                        {/* Specializations */}
                                        {(() => {
                                            const specialities = getSpecializationsInfo();
                                            if (specialities && specialities.length > 0) {
                                                const mainSpeciality = specialities[0];
                                                return (
                                                    <div className="dc-specialization" style={{ 
                                                        fontSize: '12px', 
                                                        color: '#666',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '5px'
                                                    }}>
                                                        <i className="fas fa-stethoscope" style={{ color: '#10b981' }}></i>
                                                        <span>{mainSpeciality?.specialities?.[0]?.name || mainSpeciality?.speciality_name || 'Specialization'}</span>
                                                        {specialities.length > 1 && (
                                                            <span style={{ 
                                                                color: '#3b82f6', 
                                                                fontSize: '10px',
                                                                backgroundColor: '#eff6ff',
                                                                padding: '2px 6px',
                                                                borderRadius: '10px'
                                                            }}>
                                                                +{specialities.length - 1} more
                                                            </span>
                                                        )}
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })()}
                                    </div>
                            </div>
                            <div className="dc-tags">
                                <DoctorSpecialities doctorId={doctor.id} service={true} data={doctor || []} type="full"/>
                            </div>
                        </div>
                        <div className="dc-doclocation dc-doclocationvtwo col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            {(() => {
                                const locationData = doctor?.doctor_default_location && doctor.doctor_default_location.length > 0 
                                    ? doctor.doctor_default_location[0] 
                                    : null;
                                
                                const address = locationData?.full_address || locationData?.address || doctor.address;
                                const latitude = locationData?.lat;
                                const longitude = locationData?.lng;
                                
                                return (
                                    <div className="dc-location-container" style={{ marginBottom: '10px' }}>
                                        <GoogleMapsLink 
                                            latitude={latitude}
                                            longitude={longitude}
                                            address={address}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                                color: '#666',
                                                fontSize: '14px',
                                                textDecoration: 'none'
                                            }}
                                        >
                                            <i className="ti-location-pin"></i>
                                            <span style={{ 
                                                overflow: 'hidden', 
                                                textOverflow: 'ellipsis', 
                                                whiteSpace: 'nowrap',
                                                maxWidth: '200px'
                                            }}>
                                                {address || 'Location not available'}
                                            </span>
                                            <i className="fas fa-external-link-alt" style={{ fontSize: '10px', opacity: 0.7 }}></i>
                                        </GoogleMapsLink>
                                    </div>
                                );
                            })()}
                            <DoctorAvailable doctorId={doctor.id} data={doctor} />
                            
                            <span><i className="ti-wallet"></i>Fees  {selectedCurrency} {displayPrice}</span>
                            
                            {type === "hospital" && (
                                <span><i className="ti-user"></i>{doctor.number_of_doctors?.length || 0 } Doctors</span>
                            )}
                            <span><i className="ti-thumb-up"></i>0 Votes</span>
                            <DoctorAvailable doctorId={doctor.id} data={doctor} available={true}/>
                            <div className="dc-btnarea">
                                <Link to={`/${type === "doctor" ? "doctor" : "hospital"}/${formatUrlString(doctor.display_name)}/${encryptId(doctor.id)}`} className="dc-btn">View More</Link>
                                <a href="#" className="dc-like dc-add-wishlists" data-id={doctor.id} onClick={() => addToWishlist(doctor.id)}><i className="far fa-heart"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

DoctorListCard.displayName = 'DoctorListCard';

export default DoctorListCard;
